import {
    Dashboard as DashboardIcon,
    PeopleOutline as DirectoryIcon,
    Diversity3,
    Settings as SettingsIcon
} from "@mui/icons-material";
import { Box } from "@mui/material";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useUser } from "src/allauth/auth";
import { useAppContext } from "src/context/AppContext";
import { MenuButton } from "src/theme/StyledFields";
import ProfileIcon from "src/theme/icons/ProfileIcon";
import { MenuProps } from "./PublicPagesMenu";

const CoachMenu: React.FC<MenuProps> = ({ layout = 'drawer' }) => {
    const location = useLocation();
    const user = useUser();
    const { membership } = useAppContext();
    const isAdmin = membership?.roles?.includes('admin') ?? false;

    const menuItems = [
        { path: "/dashboard", icon: DashboardIcon, label: "Dashboard", priority: true },
        // { path: "/notifications", icon: NotificationsIcon, label: "Notifications", priority: true },
        //        { path: "/coach-content", icon: SportsIcon, label: "Coach Content", priority: false },
        { path: "/my-profile", icon: ProfileIcon, label: (user.display && layout === 'header') ? `${user.display}` : "My Account", priority: false }
    ];
    if (isAdmin && layout !== 'header') {
        menuItems.splice(1, 0, { path: "/reports/team-report", icon: Diversity3, label: "Team Report", priority: false });
        menuItems.splice(1, 0, { path: "/directory", icon: DirectoryIcon, label: "Directory", priority: false });
    }
    if (layout !== 'header') {
        menuItems.push({ path: "/my-profile/settings", icon: SettingsIcon, label: "Settings", priority: false });
    }

    const renderItems = () => {
        return menuItems.map(({ path, icon: Icon, label }) => (
            <MenuButton
                key={path}
                component={Link}
                to={path}
                startIcon={<Icon fontSize="small" />}
                fullWidth={layout === 'drawer'}
                color={location.pathname === path ? "primary" : "inherit"}
                sx={{
                    justifyContent: layout === 'drawer' ? 'flex-start' : 'center',
                }}
            >
                {label}
            </MenuButton>
        ));
    };

    const wrapperStyles = {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        justifyContent: 'space-between',
        flexDirection: layout === 'drawer' ? 'column' : 'row'
    }

    return <Box data-menu-role="coach" data-menu-layout={layout} sx={wrapperStyles}>
        {renderItems()}
    </Box>;
};

export default CoachMenu;